import React from 'react';
import { UserCheck } from 'lucide-react';

interface ImpersonationLoadingDialogProps {
  targetUserName?: string;
}

export const ImpersonationLoadingDialog: React.FC<ImpersonationLoadingDialogProps> = ({ targetUserName }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
        <div className="flex flex-col items-center space-y-4">
          <div className="relative">
            <UserCheck className="w-16 h-16 text-purple-600 dark:text-purple-400" />
            <div className="absolute -bottom-1 -right-1 w-6 h-6">
              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-purple-600"></div>
            </div>
          </div>
          
          <div className="text-center">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              Switching User...
            </h3>
            {targetUserName && (
              <p className="text-gray-600 dark:text-gray-400">
                Switching to {targetUserName}
              </p>
            )}
            <p className="text-sm text-gray-500 dark:text-gray-500 mt-2">
              Refreshing permissions and navigation
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

